<div #contenedor class="contenedor" [style]="style"></div>
